import { useContext } from "react";
import { Grid } from "@mui/material";
import { useTranslation } from "react-i18next";
import { LocaleContext } from "../../../../routing/LangRouter";

//import utils
import { formatGregorianDate, formatPersianDate } from "../../../../utils/date";

//import general components
import TicketArrow from "../../../common/ticket-arrow/ticket-arrow";

//import image
import AirplaneSvg from "../../../../assets/icons/airplane.svg";

export function DomesticOrderContent({ title, information, isReturn }) {
    const { locale } = useContext(LocaleContext);
    const { t } = useTranslation();

    return (
        <Grid container item xs={12} rowGap={1}>
            {isReturn && (
                <Grid className="orders__flight-type" container item xs="auto">
                    {title}
                </Grid>
            )}

            <Grid container item xs={12} columnGap={{ xs: 1, md: 2 }}>
                <img className="orders__airline-image" src={information?.airline?.image} />

                <Grid container item xs={9} md={10} rowGap={{ xs: 0, md: 1 }}>
                    <Grid className="orders__airline-name" component="span" container item xs={12}>
                        {`${t("airline")}`} {information?.airline?.english}
                    </Grid>

                    <Grid container item xs={12} columnGap={{ xs: 1, md: 2 }}>
                        <span className="orders__departure">{information?.domestic_departure}</span>

                        <TicketArrow icon={<img src={AirplaneSvg} />} />

                        <span className="orders__destination">{information?.domestic_destination}</span>
                    </Grid>

                    <Grid container item xs={12} columnGap={1}>
                        <Grid container display={{ xs: "none", md: "flex" }}>
                            {t("departureTimeDate")}:
                        </Grid>
                        <span className="orders__date-time">
                            {locale === "fa"
                                ? `${formatPersianDate(information?.departure_date, {
                                      day: "numeric",
                                      month: "long",
                                      year: "numeric",
                                      weekday: undefined,
                                  })}
                            - ${information.departure_time.split(":", 2).join(":")}`
                                : formatGregorianDate(information?.departure_date, null, "YYYY/MM/DD") +
                                  " - " +
                                  information.departure_time.split(":", 2).join(":")}
                        </span>
                    </Grid>
                </Grid>
            </Grid>
        </Grid>
    );
}

function DomesticFlightOrder({ order }) {
    const { t } = useTranslation();

    return (
        <Grid container item xs={12} rowGap={2}>
            {!!order?.segments?.length && (
                <DomesticOrderContent title={t("departureFlight")} information={order?.segments?.[0]} isReturn={!!order?.return_segments?.length} />
            )}
            {!!order?.return_segments?.length && (
                <DomesticOrderContent
                    title={t("returnFlight")}
                    information={order?.return_segments?.[0]}
                    isReturn={!!order?.return_segments?.length}
                />
            )}
        </Grid>
    );
}

export default DomesticFlightOrder;
